import React from 'react';
import tabsContentStyles from './TabsContentStyles.module.css';

export function TabsContent(props) {
  return <div data-aos="fade-up-left" data-aos-duration="500" className={tabsContentStyles['tabs-content']}>{props.children}</div>;
}
